import { useState } from "react";
import "./WhatsApp.css";

const WHATSAPP_NUMBER = "919392173311"; 
const DEFAULT_MESSAGE = "Hi, I have a question about my fleet account.";

export default function WhatsAppButton({
  phoneNumber = WHATSAPP_NUMBER,
  message = DEFAULT_MESSAGE,
  label = "Chat on WhatsApp",
}) {
  const [hovered, setHovered] = useState(false);

  const href = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="wa-fab"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onFocus={() => setHovered(true)}
      onBlur={() => setHovered(false)}
      aria-label={label}
    >
      <span className={`wa-fab__label ${hovered ? "wa-fab__label--visible" : ""}`}>
        {label}
      </span>

      <span className="wa-fab__icon-wrap">
        <span className="wa-fab__ring" />
        <svg
          className="wa-fab__icon"
          viewBox="0 0 32 32"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            fill="currentColor"
            d="M16.004 3C9.376 3 4 8.373 4 15c0 2.34.66 4.527 1.803 6.39L4 29l7.803-1.756A11.94 11.94 0 0 0 16.004 27C22.63 27 28 21.627 28 15S22.63 3 16.004 3Zm0 21.75a9.7 9.7 0 0 1-4.95-1.354l-.355-.21-4.63 1.042 1.02-4.51-.232-.37A9.71 9.71 0 0 1 5.25 15c0-5.376 4.377-9.75 10.754-9.75 5.75 0 10.246 4.42 10.246 9.75 0 5.376-4.62 9.75-10.246 9.75Zm5.61-7.31c-.307-.154-1.816-.897-2.098-1-.28-.103-.484-.154-.687.154-.204.309-.79 1-.968 1.206-.178.206-.357.232-.663.077-.307-.154-1.296-.478-2.469-1.524-.913-.814-1.53-1.818-1.708-2.127-.178-.309-.02-.476.135-.63.138-.137.307-.36.46-.54.154-.18.205-.309.307-.514.103-.206.052-.386-.026-.54-.077-.154-.687-1.656-.941-2.269-.248-.596-.5-.515-.687-.524-.178-.008-.383-.01-.588-.01-.204 0-.537.077-.818.386-.28.309-1.07 1.047-1.07 2.55 0 1.503 1.096 2.957 1.25 3.163.153.206 2.156 3.29 5.226 4.613.73.315 1.298.503 1.741.643.731.232 1.396.2 1.922.121.586-.088 1.816-.742 2.072-1.459.256-.716.256-1.33.179-1.458-.077-.129-.28-.206-.588-.36Z"
          />
        </svg>
      </span>
    </a>
  );
}